import React from 'react';
import CRUDManager from '../../../../shared/components/crud/CRUDManager';
import { stockManagementConfig } from '../config/stockManagementConfig';

export default function StockManagement() {
  return <CRUDManager config={stockManagementConfig} />;
}